import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db, auth } from "../../utils/Firebase-Config";
import { createMvelioSubscription } from "../../Services/CreatMvelioSubscription"; // Adjust path as needed
import "./Plans.css";

function Plans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const q = query(collection(db, "subscription_plans"), where("active", "==", true));
        const querySnapshot = await getDocs(q);
        const fetchedPlans = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }));

        // Sort plans by price from lowest to highest
        fetchedPlans.sort((a, b) => a.amount - b.amount);
        setPlans(fetchedPlans);
      } catch (error) {
        console.error("Error fetching Mvelio plans:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  // 1. Accept both priceId and tierName
  const handleSubscribe = async (priceId, tierName) => {
    const user = auth.currentUser;
    if (!user) {
      alert("Please sign in or register before subscribing!");
      window.location.assign("/signup");
      return;
    }

    // 2. Pass all three parameters in the correct order!
    await createMvelioSubscription(priceId, tierName, user);
  };


  if (loading) return <div className="loading">Loading Mvelio Plans...</div>;

  return (
    <div className="plans-layout">

      <h2>Select Your Mvelio Protection Plan</h2>

      <div className="plans-grid">
        {plans.map((plan) => (
          <div key={plan.id} className="plan-card">
            <h3>{plan.name}</h3>
            <p className="price">${plan.amount} / {plan.interval}</p>
            <p className="desc">{plan.description}</p>

            {/* Pass BOTH plan.priceId and plan.name (tierName) */}
            <button onClick={() => handleSubscribe(plan.priceId, plan.name)}>
              Subscribe Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Plans;
